module.exports = __webpack_public_path__ + "img/issue-icon13.e7b75c3.png";